import {
  setCookie,
  getCookie,
  removeCookie,
} from '../../cookie/cookieService';

const PRIMARY_REFERRER = 'primary';
const QUICK_LINK_REFERRER = 'quick-link';
const PROPERTY_TYPE_TILE_REFERRER = 'propertytype-tile';
const LOCATION_TILE_REFERRER = 'location-tile';
const REFINEMENT_REFERRER = 'refinement';

const COOKIE_FIELD_SRP_REFERRER = 'rca-srp-referrer';

export function referAsSRPRefinement() {
  setCookie(COOKIE_FIELD_SRP_REFERRER, 'refinement');
}

export function getReferrer() {
  const referrer = getCookie(COOKIE_FIELD_SRP_REFERRER);
  removeCookie(COOKIE_FIELD_SRP_REFERRER);
  return referrer;
}

function mapReferrerToProp2(referrer) {
  if (referrer === PRIMARY_REFERRER) { return 'hp:primary-search'; }
  if (referrer === QUICK_LINK_REFERRER) { return 'hp:quick-link-search'; }
  if (referrer === PROPERTY_TYPE_TILE_REFERRER) { return 'hp:propertytype-tile-search'; }
  if (referrer === LOCATION_TILE_REFERRER) { return 'hp:location-tile-search'; }
  if (referrer === REFINEMENT_REFERRER) { return 'srp:refinement-search'; }
  return undefined;
}

export function populateProp2() {
  const referrer = getReferrer();
  return mapReferrerToProp2(referrer);
}
